<template>
    <el-container>
        <el-header>
            <el-form :inline="true" :model="fromAlarmSend" ref="fromAlarmSend" class="demo-form-inline">
                <td-permission :permissions="permissionsQuery">
                    <div slot="havePermission">
                        <el-form-item :label="$t('common.PUSH_DEXTINATION')" prop="iPushDestination">
                            <td-select v-model="fromAlarmSend.iPushDestination" :options="pushDestination" placeholder="common.PLEASE_SELECT"></td-select>
                        </el-form-item>
                        <el-form-item :label="$t('common.URL_ADDRESS')" prop="sPushUrl">
                            <td-input v-model="fromAlarmSend.sPushUrl"></td-input>
                        </el-form-item>
                        <el-form-item :label="$t('common.SUBSCRIBE_GROUP_NAME')" prop="sAlarmSubscriptionName">
                            <td-input v-model="fromAlarmSend.sAlarmSubscriptionName"></td-input>
                        </el-form-item>
                    </div>
                </td-permission>
                <el-form-item class="paddingLeft10">
                    <td-button type="primary" :permissions="permissionsQuery" @getPermissionsStatus="getPermissionsStatus" :loading="loading" @click="btnClickQuery">{{
                        $t('common.QUERY')
                    }}</td-button>
                    <td-button type="button" :permissions="permissionsAdd" @click="btnAddEvent">{{ $t('common.ADD') }}</td-button>
                    <td-button type="button" :permissions="permissionsDelete" @click="btnDeleteSend">{{ $t('common.DELETE') }}</td-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                ref="tableInfo"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                :permissions="permissionsQuery"
                :rowKey="rowKey"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-eventInfo
                v-if="dialogSendVisible"
                :isAddData="isAddData"
                :dialogSendVisible="dialogSendVisible"
                :pushDestination="pushDestination"
                :systemNameDisabled="systemNameDisabled"
                :editItem="editItem"
                :title="title"
                @sendDialogClose="sendDialogClose"
                @submit="submit"
            ></dialog-eventInfo>
        </el-main>
    </el-container>
</template>

<script>
import api from './assets/api.js';
import dialogEventInfo from './components/dialogSendInfo.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-eventInfo': dialogEventInfo
    },
    // 定义数据
    data() {
        return {
            fromAlarmSend: { sAlarmSubscriptionName: '', sPushUrl: '', iPushDestination: '' },
            permissionsQuery: ['alarmSend:view'],
            permissionsAdd: ['alarmSend:add'],
            permissionsDelete: ['alarmSend:del'],
            editItem: '',
            rowKey: 'sId',
            pushDestination: [
                {
                    value: this.$common.pushDestination.THIRD_PARTY_SYSTEM,
                    label: this.$t('common.THIRD_PARTY_SYSTEM')
                }
            ],
            dialogSendVisible: false,
            tableData: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            columns: [
                {
                    prop: 'iPushDestination',
                    label: this.$t('common.PUSH_DEXTINATION'),
                    tableWidth: '120',
                    align: 'center',
                    render: (createElement, params) => {
                        let context = '';
                        if (params.row.iPushDestination === this.$common.pushDestination.THIRD_PARTY_SYSTEM) {
                            context = this.$t('common.THIRD_PARTY_SYSTEM');
                        }
                        return createElement('span', context);
                    }
                },
                {
                    prop: 'iPushWay',
                    label: this.$t('common.PUSH_WAY'),
                    tableWidth: '120',
                    align: 'center',
                    render: (createElement, params) => {
                        let context = '';
                        if (params.row.iPushWay === this.$common.pushWay.WEB_SERVICE) {
                            context = this.$t('common.WEB_SERVICE');
                        }
                        return createElement('span', context);
                    }
                },
                {
                    prop: 'sSystemName',
                    label: this.$t('common.SYSFLG')
                },
                {
                    prop: 'sPushUrl',
                    label: this.$t('common.URL_ADDRESS')
                },
                {
                    prop: 'sAlarmSubscriptionName',
                    label: this.$t('common.SUBSCRIBE_GROUP_NAME')
                },
                {
                    prop: 'sDescribe',
                    label: this.$t('common.DESCRIPTION')
                },
                {
                    prop: 'iStartStatus',
                    label: this.$t('common.START_STATUS'),
                    tableWidth: '100',
                    align: 'center',
                    render: (createElement, params) => {
                        let context = '';
                        if (params.row.iStartStatus === 0) {
                            context = this.$t('common.DISABLE');
                        } else if (params.row.iStartStatus === 1) {
                            context = this.$t('common.ENABLE');
                        }
                        return createElement('span', context);
                    }
                },
                {
                    prop: '',
                    label: this.$t('common.OPERATE'),
                    tableWidth: '90',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: ['alarmSend:edit'] },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: ['alarmSend:del'] },
                                    on: {
                                        click: () => {
                                            this.btnDelete([params.row.sId]);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.submit();
        },
        getPermissionsStatus(permissions) {
            if (permissions) {
                this.btnQuery(); // 进行页面初始化数据的加载
            }
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.submit();
        },
        //查询点击按钮
        btnClickQuery() {
            this.currentPage = 1;
            this.btnQuery();
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            let param = {
                iPushDestination: this.fromAlarmSend.iPushDestination,
                sAlarmSubscriptionName: this.fromAlarmSend.sAlarmSubscriptionName,
                sPushUrl: this.fromAlarmSend.sPushUrl,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                isPage: true
            };
            api.getAlarmSend(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('alarm/getAlarmSend', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        // 添加
        btnAddEvent() {
            this.title = this.$t('common.ADD'); // 标题
            this.isAddData = true;
            this.dialogSendVisible = true;
            this.systemNameDisabled = false;
        },
        // 编辑
        btnExit(row) {
            this.editItem = row;
            this.title = this.$t('common.EDIT');
            this.isAddData = false;
            this.dialogSendVisible = true;
            this.systemNameDisabled = true;
        },
        // 获取选中表格数据的id
        getTableSelectId() {
            let selectData = this.$refs.tableInfo.getSelectAllRows();
            let tableId = [];
            for (let i = 0; i < selectData.length; i++) {
                tableId.push(selectData[i].sId);
            }
            return tableId;
        },
        // 批量删除
        btnDeleteSend() {
            let tableId = this.getTableSelectId();
            if (tableId.length === 0) {
                this.$message({ showClose: true, message: this.$t('common.PLEASE_SELECT'), type: 'warning' });
                return;
            }
            this.btnDelete(tableId);
        },
        // 删除接口
        btnDelete(sId) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    api.deleteAlarmSend(JSON.stringify(sId), response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('alarm/deleteAlarmSend', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                        this.submit();
                    });
                })
                .catch(() => {});
        },
        // 组件关闭需要调用的方法
        submit() {
            this.btnQuery();
        },
        // 关闭页面
        sendDialogClose() {
            this.dialogSendVisible = false;
        }
    }
};
</script>
